export default {
  typography: {
    fontFamily: "Chivo"
  },
  // shadows: ["none", "0px 6px 24px #3344541A"],
  overrides: {
    MuiAppBar: {
      root: {
        borderBottom: "2px solid rgba(0,0,0, 0.25)",
        marginBottom: "48px"
      }
    },
    MuiButton: {
      root: {
        textTransform: "none",
        padding: "12px 16px",
        minWidth: "42px",
        borderRadius: "24px"
      },
      label: {
        fontWeight: "bold",
        whiteSpace: "nowrap"
      }
    },
    MuiInputLabel: {
      outlined: {
        transform: "translate(25px, 16.5px) scale(1)"
      }
    },
    MuiSelect: {
      outlined: {
        "&:focus": {
          borderRadius: "24px"
        }
      }
    },
    MuiOutlinedInput: {
      root: {
        borderRadius: "24px"
      },
      input: {
        borderRadius: "24px",
        padding: "14.5px 25px"
      }
    },
    MuiPaper: {
      rounded: {
        borderRadius: "8px"
      }
    },
    MuiSvgIcon: {
      fontSizeLarge: {
        fontSize: "3rem"
      }
    },
    MuiTabs: {
      root: {
        borderBottom: `1px solid rgba(0,0,0, 0.25)`
      }
    },
    MuiIconButton: {
      root: {
        color: "inherit"
      },
      edgeEnd: {
        marginLeft: -12,
        marginRight: 0
      }
    },
    MuiAccordionSummary: {
      root: {
        flexDirection: "row-reverse"
      }
    },
    MuiAccordionDetails: {
      root: {
        "&:first-child": {
          marginLeft: 32
        }
      }
    }
  }
};
